import { Maybe } from "generated/graphql";
import { History } from "history";

enum keys {
  TOKEN = "@malibu/TOKEN",
}

type AccessToken = { token: string | Maybe<string> | undefined, next?: string };

class Auth {
  history?: History<BaseLocationState>;

  constructor(history?: History<BaseLocationState>) {
    this.history = history;
  }

  public login(props: AccessToken): void {
    localStorage.setItem(keys.TOKEN, JSON.stringify(props));
    if (
      this.history &&
      this.history.location.state &&
      this.history.location.state?.from
    ) {
      window.location.href = this.history.location.state?.from!.pathname;
    }
    if (props.next) {
      window.location.href = props.next
    } else {
      window.location.href = "/tournaments";
    }
  }

  public getToken(): AuthToken | null {
    const authToken = this.accessToken();
    if (authToken?.token) {
      return {
        // @ts-ignore
        token: authToken?.token,
      };
    }
    return null;
  }

  public accessToken(): AccessToken | null {
    const token = localStorage.getItem(keys.TOKEN);
    if (token) {
      return JSON.parse(token);
    }
    return null;
  }

  public signOut(): void {
    localStorage.removeItem(keys.TOKEN);
    window.location.replace("/");
  }

  public clearToken(): void {
    localStorage.removeItem(keys.TOKEN);
  }
}

export default Auth;
